import MenuItem from './lib/MenuItem';

const init = (menuItem: HTMLLIElement) => {
  (() => new MenuItem(menuItem))();
};

export default init;
